<template>
    <div id="sinester-providers-admin">
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="barSettings">
                    <div class="row ">
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                            <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3"
                                v-model="pagination.current_page" :total-rows="pagination.total"
                                :per-page="pagination.per_page" aria-controls="my-table"
                                v-on:change="onChange"></b-pagination>
                        </div>

                        <div class="col-12 col-md-2">
                            <select v-model="client_id" name="client_id" id="client_id" class="required">
                                <option :value="0">Seleccione un cliente</option>
                                <option v-for="client in clients" :value="client.sku">
                                    {{ client.sku }} -
                                    <template v-if="client.tipo_per === 1">{{ client.nombre }} {{ client.paterno }}
                                        {{ client.materno }}
                                    </template>
                                    <template v-else>{{ client.nmComPerMoral }}</template>
                                </option>
                            </select>
                        </div>
                        <div class="col-12 col-md-2">
                            <select data-select="on" v-model="prov_role_id" name="provider_id" id="provider_id"
                                v-on:change="handleChangeProvider($event)" class="required">
                                <option :value="0">Tipo de Proveedor*</option>
                                <option v-for="prov in providers" :value="prov.id" :key="prov.id">
                                    {{ prov.name }}
                                </option>
                            </select>
                        </div>
                        <div class="col-12 col-md-2">

                            <select ref="companySelect" name="company_id" v-model="params.company_id" id="company_id"
                                v-on:change="loadSinisters()">
                                <option :value="0">Proveedores*</option>
                                <option v-for="lprov in list_providers" :value="lprov.id" :key="lprov.id">
                                    {{ lprov.genericName }}
                                </option>
                            </select>
                        </div>
                        <div class="col col-xl-2">
                            <input id="filter-input" class="al-inputs scr-input" v-model="filter" type="search"
                                placeholder="Buscar por palabra">
                            <label for="filter-input" class="scr-supertext scr-extra">Buscar por palabra</label>
                        </div>
                        <div class="col col-xl-1">
                            <select class="float" v-model="params.limit" v-on:change="changeLimit">
                                <option :value="10">10</option>
                                <option :value="20">20</option>
                                <option :value="30">30</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <b-table sticky-header="100vh" stacked="md" id="my-table" striped hover :fields="fields"
                            :busy="isBusy" :items="pagination.data" :filter="filter">

                            <!-- A virtual column -->
                            <template #cell(id)="{ item }">
                                <span>{{ item.id }}</span>
                            </template>
                            <template #cell(fecha)="{ item }">
                                <span>{{ item.fecha }}</span>
                            </template>
                            <template #cell(membresia)="{ item }">
                                <span>{{ item.membresia }}</span>
                            </template>
                            <template #cell(cantidad)="{ item }">
                                <span>{{ item.cantidad }}</span>
                            </template>
                            <template #cell(precio_tabulador)="{ item }">
                                <span>{{ formatCurrency(item.precio_tabulador) }}</span>
                            </template>
                            <template #cell(subtotal)="{ item }">
                                <span>{{ formatCurrency(item.subtotal) }}</span>
                            </template>
                            <template #cell(8_%)="{ item }">
                                <span>{{ item.ocho_iva ? formatPrice(item.ocho_iva) : 'N/A' }}</span>
                            </template>
                            <template #cell(16_%)="{ item }">
                                <span>{{ item.sixteen_iva ? formatPrice(item.sixteen_iva) : 'N/A' }}</span>
                            </template>
                            <template #cell(total)="{ item }">
                                <span>{{ formatCurrency(item.total) }}</span>
                            </template>

                            <template #cell(1.6_porciento)="{ item }">
                                <span>{{ formatCurrency(item.one_six_red) }}</span>
                            </template>

                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                        </b-table>
                        <div class="col col-xl-2">
                            <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3"
                                v-model="pagination.current_page" :total-rows="pagination.total"
                                :per-page="pagination.per_page" aria-controls="my-table"
                                v-on:change="onChange"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>

        </main>
    </div>
</template>

<script>
import { myMixins } from "../mixins/myMixins";
import { sinisterService } from "../../Services/Sinister.service";
import { clientsService } from "../../Services/Clients.service";
import { rolesService } from "../../Services/Roles.service";

export default {
    name: "sinester-providers-admin",
    mixins: [myMixins],
    props: {
        supplier_id: {
            type: Number,
            required: true
        },
        role_id: {
            type: Number,
            required: true
        },
        kind_consult: {
            type: Number || null,
            required: false,
            default: 0
        },
    },
    data() {
        return {
            providers: [],
            list_providers: [],
            clients: [],
            prov_role_id: 0,
            specialist_id: 0,
            inst_id: 0,
            modificar: false,
            isBusy: false,
            filter: null,
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            params: {
                page: 1,
                limit: 10,
                company_id: 0,
            },

            client_id: 0,
            fields: [
                { key: 'id' },
                { key: 'fecha' },
                { key: 'membresia' },
                { key: 'cantidad' },
                { key: 'precio_tabulador' },
                { key: 'subtotal' },
                { key: '8_%' },
                { key: '16_%' },
                { key: 'total' },
                { key: '1.6_porciento' },
            ],

        }
    },
    methods: {
        onChange(page) {
            this.params.page = page;
            this.loadSinisters();
        },
        handleChangeProvider(e) {
            this.selectCompanyByRoleProvider(e);
        },
        changeLimit() {
            this.index();
        },
        async loadSinisters() {
            this.isBusy = true;
            //ESTE IF ES PARA CUANDO ES UNA INSTITUCION ESTA ACCEDIENDO A VER LOS SINIESTROS DE UN ESPECIALISTA
            // Accede al elemento select a través de la referencia
            let selectElement = this.$refs.companySelect;
            // Obtiene el option seleccionado
            let selectedOption = selectElement.options[selectElement.selectedIndex];
            //Obtenemos el valor de prov_role_id para saber que tabla de siniestros cargar
            switch (this.prov_role_id) {
                case 4:
                    this.params.table_name = 'sinisters';
                    break;
                case 7:
                    this.params.table_name = 'sinister_hospitals';
                    break;
                case 10:
                case 11:
                case 12:
                case 13:
                    this.params.table_name = 'sinister_records';
                    break;

            }
            //SKU DEL CLIENTE
            this.params.client_id = this.client_id;
            //console.log('params', this.params);
            this.pagination = await sinisterService.getSinisterCollection(this.params);
            //console.log('pagination', this.pagination.process);
            if (this.pagination.process) {
                this.getAlert(this.pagination.process);
            }
            this.isBusy = false;
        },

        async index() {
            this.providers = await rolesService.getProvidersForSinester();
            this.clients = await clientsService.getMany({ limit: 0 });
        },
    },
    async created() {
        await this.index();
    }
}
</script>
